import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { VehicleResp } from '../models/vehicles/vehicle-resp';
import { HttpCemex } from '../services/api.service';

@Injectable()
export class VehiclesService {
  constructor(private http: HttpCemex) {}

  getVehicles(haulerId: number): Observable<VehicleResp> {
    return this.http.get(`/v7/dm/vehicles?haulerId=${haulerId}`);
  }
}
